module.exports = "/_next/static/images/harajuku_sunday_kunch-69189e03b81142505fe89ac0b49e6d46.jpg";